module.exports = __webpack_public_path__ + "img/daynight.080bdbca.png";